/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest
 */
export interface FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest
     */
    Game: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest
     */
    Skus: Array<string>;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest interface.
 */
export function instanceOfFxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest(value: object): value is FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('Skus' in value) || value['Skus'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestFromJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'Skus': json['Skus'],
    };
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestToJSON(json: any): FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestToJSONTyped(json, false);
}

export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestToJSONTyped(value?: FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'Skus': value['Skus'],
    };
}

